import "./About.css";
import Container from "react-bootstrap/Container";
import { Row, Col } from "react-bootstrap";
import CMC from "../../assets/cmc.jpg";

function About() {
  return (
    <section className="about" id="about">
      <Container className="about">
        <Row>
          <Col lg={5}>
            <div className="pt-3">
              <div className="section-title">
                CMC BATCH 1972
              </div>
              {/* <div className="section-subtitle">Lorem Ipsum</div> */}
              <div className="About-cmc">
                Welcome to the official website of the 16th MBBS batch of the
                Calicut Medical College, Kozhikode. Our batch is a vibrant
                mosaic of diverse personalities, each bringing their unique
                character and interest to the table. Despite our differences we
                were united by a common thread of friendship that made our
                journey unforgettable. From the day we set foot on the campus,
                the 16th batch of Calicut Medical college embraced a journey
                filled with learning, growth and unforgettable experiences. Our
                dedication to the academics was matched only by our enthusiasm
                for cultural and sports events. We celebrated festivals
                together, organized exhibitions and medical camps, and even
                found time to unwind with spontaneous adventures. Our website
                stands as a testament to the incredible bonds we formed, the
                milestones we achieved, and the cherished memories we created.
                Each section of our website will transport you through a journey
                of excellence, creativity, and the spirit of unity that made our
                batch truly special. Feel free to explore our gallery, read
                about our achievements, and connect with fellow batchmates. We
                invite you to join us in celebrating the legacy of the 16th MBBS
                Batch—a legacy built on passion, friendship, and unwavering
                determination. Welcome to a walk down memory lane!
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div className="">
              <div className="d-flex justify-content-end">
                <img className="cmc-image img-fluid" src={CMC}></img>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default About;
